import React, { Component } from 'react';
import { toast } from 'react-toastify';
import {
  ProgressIndicatorSkeleton,
  Modal,
  FormItem,
  RadioButton,
  TextArea,
} from 'carbon-components-react';

import Numeral from 'numeral';
import 'numeral/locales/pt-br';

import queryString from 'qs';
import NumberFormat from 'react-number-format';
import { NavLink } from 'react-router-dom';
import { getByDmService, insertDmService } from '../../../../../services/Api';
import { Breadcrumb, TableDefault, Tabs } from '../../../../../components';

class Main extends Component {
  constructor(props) {
    super(props);

    this.state = {
      search: '',
      page: 1,
      pageSize: 100,
      totalItems: 0,
      orderBy: 'Descricao',
      order: '',
      urlDelete: null,
      urlLoad: '/Extrato/{id}',
      // data: null,
      user: null,
      isLoading: false,
      // actionModalAlerta: false,
      showModalBudgetAtual: false,
      showModalBudgetAutomatico: false,
      tipo: 1,
      tipoOperacaoExtrato: 1,
      valorAdicional: null,
      saldoAtual: 0,
      motivo: '',
      defaultFilters: '',
      updatedSaldoMensal: null,
    };
  }

  componentDidMount = async () => {
    await this.getItems();
    Numeral.locale('pt-br');
    const { history, match } = this.props;
    history.listen(location => {
      const defaultFilters = `periodo=${location.pathname.replace(match.url, '').replace('/', '')}`;
      console.log(defaultFilters);
      this.setState({ defaultFilters }, () => {
        this.tableList.getItems();
      });
    });
  };

  getItems = async () => {
    const { match, location } = this.props;
    let user = null;

    const query = queryString.parse(location.search.slice(1));

    const { msg } = query;
    if (msg) toast.success(msg);
    try {
      // data = await getByDmService('/Extrato', match.params.id);
      user = await getByDmService('/Usuario', match.params.id);
      const { saldoMensal, saldoAtual } = user;
      const urlLoad = `/Extrato/${user.id}`;
      const defaultFilters = `periodo=${location.pathname.replace(match.url, '').replace('/', '')}`;

      this.setState({
        urlLoad,
        defaultFilters,
        user,
        saldoMensal,
        saldoAtual,
        isLoading: false,
      });
    } catch (e) {
      toast.error('Ocorreu um erro ao carregar os dados');
      this.setState({ /* data: null, error: e, */ isLoading: false });
    }
  };

  toggleModalBudgetAutomatico = () => {
    this.setState(prevState => ({
      showModalBudgetAutomatico: !prevState.showModalBudgetAutomatico,
    }));
  };

  toggleModalBudgetAtual = () => {
    this.setState(prevState => ({ showModalBudgetAtual: !prevState.showModalBudgetAtual }));
  };

  actionModalBudgetAutomatico = async () => {
    const { user, updatedSaldoMensal, tipo } = this.state;
    const obj = {
      Usuarios: [user.id],
      ValorAtual: 0,
      ValorMensal:
        typeof updatedSaldoMensal !== 'string'
          ? updatedSaldoMensal
          : updatedSaldoMensal.replace(/[Rr$ .]/g, '').replace(',', '.'),
      StatusOrcamento: tipo,
    };

    try {
      await insertDmService('/Orcamento', obj);
      toast.success('Dados atualizados com sucesso');
      await this.getItems();
      this.tableList.getItems();
    } catch (e) {
      this.errorHandler(e);
    }
    this.toggleModalBudgetAutomatico();
    this.setState({ updatedSaldoMensal: null });
  };

  actionModalBudgetAtual = async () => {
    const { user, tipoOperacaoExtrato, motivo, valorAdicional } = this.state;
    const obj = {
      Usuarios: [user.id],
      ValorAtual:
        typeof valorAdicional !== 'string'
          ? valorAdicional
          : valorAdicional.replace(/[Rr$ .]/g, '').replace(',', '.'),
      ValorMensal: 0,
      TipoOperacaoExtrato: tipoOperacaoExtrato,
      Motivo: motivo,
    };

    try {
      await insertDmService('/Orcamento', obj);
      toast.success('Dados atualizados com sucesso');
      this.getItems();
      this.tableList.getItems();
      this.toggleModalBudgetAtual();
      this.setState({ valorAdicional: null, motivo: '' });
    } catch (e) {
      this.errorHandler(e);
    }
  };

  errorHandler = err => {
    if (typeof err.error.response.data.modelState !== 'undefined') {
      let error = 'Ocorreu o seguinte erro: ';

      const erros = err.error.response.data.modelState;
      for (const p in erros) {
        let name = p.replace('model.', '');
        name = name[0].toUpperCase() + name.slice(1);
        error += `${erros[p]}; `;
      }
      toast.warning(error.trim());
    } else {
      toast.error('Ocorreu um erro ao salvar os dados, tente novamente mais tarde');
    }
  };

  onChangeText = event => {
    this.setState({ [event.target.id]: event.target.value /* , isEdited: true */ });
  };

  onChangeTipo = tipo => {
    this.setState({ tipo });
  };

  onChangeTipoOperacao = tipo => {
    this.setState({ tipoOperacaoExtrato: tipo });
  };

  render() {
    const {
      page,
      pageSize,
      totalItems,
      search,
      order,
      orderBy,
      urlDelete,
      urlEdit,
      urlLoad,
      defaultFilters,
      saldoAtual,
      user,
      isLoading,
      saldoMensal,
      updatedSaldoMensal,
      tipo,
      motivo,
      valorAdicional,
      tipoOperacaoExtrato,
      showModalBudgetAtual,
      showModalBudgetAutomatico,
    } = this.state;

    const { match } = this.props;

    if (isLoading) {
      return (
        <div>
          <Breadcrumb title="---- - ----" description="----" />
          <section className="content-wrapper content-wrapper--large">
            <ProgressIndicatorSkeleton />
          </section>
        </div>
      );
    }

    return (
      <div>
        {user && (
          <div>
            <Breadcrumb
              title={user.nome}
              description={user.nivel.nome}
              renderRight={(() => (
                <div className="flex v-sm-margin">
                  <button
                    className="bx--btn btn-secondary-outlined h-sm-margin"
                    onClick={this.toggleModalBudgetAutomatico}
                    type="submit"
                  >
                    Alterar Budget Automático
                  </button>
                  <button
                    className="bx--btn btn-secondary-color h-sm-margin"
                    onClick={this.toggleModalBudgetAtual}
                    type="submit"
                  >
                    Alterar Budget Atual
                  </button>
                </div>
              ))()}
              renderLeft={(() => (
                <div className="breadcrumb-left-actions">
                  <NavLink to="/admin/gestao/budgets">
                    <svg width="16" height="14" viewBox="0 0 16 14">
                      <path d="M4.044 8.003l4.09 3.905-1.374 1.453-6.763-6.356L6.759.639 8.135 2.09 4.043 6.003h11.954v2H4.044z" />
                    </svg>
                  </NavLink>
                </div>
              ))()}
            />
            <section className="content-wrapper content-wrapper--large budget-management">
              <div className="table-uniforms">
                <ul className="totalizadores">
                  <li>
                    Saldo Atual:
                    <strong>{saldoAtual}</strong>
                  </li>
                  <li>
                    Budget Mensal:
                    <strong>{saldoMensal}</strong>
                  </li>
                </ul>
                <Tabs
                  sections={[
                    { title: 'Todos', path: `${match.url}` },
                    { title: '1 ano', path: `${match.url}/1` },
                    { title: '6 meses', path: `${match.url}/2` },
                    { title: '3 meses', path: `${match.url}/3` },
                    { title: '1 meses', path: `${match.url}/4` },
                    { title: '15 dias', path: `${match.url}/5` },
                    { title: '7 dias', path: `${match.url}/6` },
                  ]}
                />

                <TableDefault
                  search={search}
                  order={order}
                  orderBy={orderBy}
                  page={page}
                  pageSize={pageSize}
                  totalItems={totalItems}
                  urlDelete={urlDelete}
                  urlEdit={urlEdit}
                  urlLoad={urlLoad}
                  defaultFilters={defaultFilters}
                  onRef={ref => {
                    this.tableList = ref;
                  }}
                  displayActions={false}
                />
              </div>
              <Modal
                open={showModalBudgetAutomatico}
                onRequestSubmit={this.actionModalBudgetAutomatico}
                onRequestClose={this.toggleModalBudgetAutomatico}
                modalHeading="Setar Budget Automático"
                primaryButtonText="Confirmar"
                secondaryButtonText="Cancelar"
                className="ofauto"
              >
                <div>
                  <p>
                    Insira o valor que você deseja para
                    <strong>{` ${user.nome}`}</strong>
                    {'.'}
                  </p>
                  <FormItem>
                    <label className="bx--label">
                      <strong>Budget Mensal</strong>
                      (Crédito Automático)
                    </label>
                    <NumberFormat
                      getInputRef={ref => {
                        this.saldoMensalRef = ref;
                      }}
                      id="updatedSaldoMensal"
                      className="bx--text-input bx--text__input"
                      decimalSeparator=","
                      fixedDecimalScale
                      thousandSeparator="."
                      prefix="R$ "
                      placeholder="R$ 0,00"
                      value={updatedSaldoMensal}
                      allowNegative={false}
                      decimalScale={2}
                      onValueChange={(values, e) => {
                        this.setState({
                          [e.target.id]: values.value ? Number(values.value) : null,
                          // isEdited: true,
                        });
                      }}
                      onFocus={() => {
                        if (!saldoMensal && this.saldoMensalRef) {
                          this.saldoMensalRef.value = '';
                        }
                      }}
                    />
                  </FormItem>
                  <FormItem>
                    <RadioButton
                      name="tipo"
                      onChange={this.onChangeTipo}
                      checked={tipo === 1}
                      value={1}
                      labelText="Recorrente"
                    />
                    <span className="legend-budget">
                      O budget entra automático e soma com o valor que já estiver.
                    </span>                    
                  </FormItem>
                  <FormItem>
                    <RadioButton
                      name="tipo"
                      onChange={this.onChangeTipo}
                      checked={tipo === 2}
                      value={2}
                      labelText="Saldo incial"
                    />
                    <span className="legend-budget">
                       O budget entra automático e zera o valor que já estiver.
                    </span>
                  </FormItem>
                </div>
              </Modal>
              <Modal
                open={showModalBudgetAtual}
                onRequestSubmit={this.actionModalBudgetAtual}
                onRequestClose={this.toggleModalBudgetAtual}
                modalHeading="Alterar Budget Atual"
                primaryButtonText="Confirmar"
                secondaryButtonText="Cancelar"
                className="ofauto"
              >
                <div>
                  <p>
                    Insira o valor que você deseja para
                    <strong>{` ${user.nome}`}</strong>
                    {'.'}
                  </p>
                  <FormItem>
                    <RadioButton
                      name="tipoOperacaoExtrato"
                      onChange={this.onChangeTipoOperacao}
                      checked={tipoOperacaoExtrato === 1}
                      value={1}
                      labelText="Crédito"
                    />
                  </FormItem>
                  <FormItem>
                    <RadioButton
                      name="tipoOperacaoExtrato"
                      onChange={this.onChangeTipoOperacao}
                      checked={tipoOperacaoExtrato === 2}
                      value={2}
                      labelText="Débito"
                    />
                  </FormItem>
                  <FormItem>
                    <RadioButton
                      name="tipoOperacaoExtrato"
                      onChange={this.onChangeTipoOperacao}
                      checked={tipoOperacaoExtrato === 3}
                      value={3}
                      labelText="Saldo incial"
                    />
                  </FormItem>
                  <FormItem>
                    <label htmlFor="valorAdicional" className="bx--label">
                      Adicionar valor
                    </label>
                    <NumberFormat
                      getInputRef={ref => {
                        this.valorAdicionalRef = ref;
                      }}
                      id="valorAdicional"
                      className="bx--text-input bx--text__input"
                      decimalSeparator=","
                      fixedDecimalScale
                      thousandSeparator="."
                      prefix="R$ "
                      placeholder="R$ 0,00"
                      value={valorAdicional}
                      allowNegative={false}
                      decimalScale={2}
                      onValueChange={(values, e) => {
                        this.setState({
                          [e.target.id]: values.value ? Number(values.value) : null,
                          // isEdited: true,
                        });
                      }}
                      onFocus={() => {
                        if (!valorAdicional && this.valorAdicionalRef) {
                          this.valorAdicionalRef.value = '';
                        }
                      }}
                    />
                  </FormItem>
                  <FormItem>
                    <TextArea
                      id="motivo"
                      labelText="Motivo"
                      onChange={this.onChangeText}
                      value={motivo}
                      placeholder="Ex: ajuste de budget."
                      invalidText="Preencha uma descrição com no mínimo 10 caracteres"
                      invalid={motivo.length < 10}
                    />
                  </FormItem>
                </div>
              </Modal>
            </section>
          </div>
        )}
      </div>
    );
  }
}

export default Main;



// WEBPACK FOOTER //
// ./src/screens/admin/Gestao/Budget/Edit/Main.js